

export default class OS {
  ua = navigator.userAgent

  android() {
    return this.ua.includes('Android')
  }

  ios() {
    return /iPad|iPhone|iPod/.test(this.ua)
  }

  desktop() {
    return this.macos() || this.windows() || this.linux()
  }

  mobile() {
    return !this.desktop()
  }

  macos() {
    return this.ua.includes('Macintosh');
  }
  linux() {
    return this.ua.includes('Linux') && !this.android() && !this.macos()
  }

  windows() {
    return this.ua.includes('Windows')
  }

  arch() {
    if (this.archx64()) return 'x86_64'
    if (this.archarm64()) return 'arm64'
    if (this.archarmv7()) return 'armv7'
  }

  archarmv7() {
    return this.ua.includes('armv7') ||
      this.ua.includes('armhf')
  }

  // Most browsers on Windows on ARM still say "Win64; x64", so detectArch()
  // also asks userAgentData. Some do say ARM64, and Linux says aarch64.
  archarm64() {
    return /arm64|aarch64/i.test(this.ua)
  }

  archx64() {
    return this.ua.includes('x86_64')
  }

  // Async best-effort architecture detection.
  // Returns { arch: 'x86_64'|'arm64', confidence: 'high'|'low' }.
  // - Chrome/Edge/Brave expose architecture via userAgentData (high confidence).
  // - UA sniffing catches Linux/Windows arm64 strings (high confidence).
  // - Safari & Firefox on macOS mask the architecture entirely; we default to
  //   arm64 (low confidence) since Apple Silicon is the dominant Mac since 2020.
  async detectArch() {
    if (this.archarm64()) return { arch: 'arm64', confidence: 'high' }
    if (this.archx64()) return { arch: 'x86_64', confidence: 'high' }

    if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
      try {
        const data = await navigator.userAgentData.getHighEntropyValues(['architecture'])
        if (data.architecture === 'arm') return { arch: 'arm64', confidence: 'high' }
        if (data.architecture === 'x86') return { arch: 'x86_64', confidence: 'high' }
      } catch (e) { /* fall through */ }
    }

    if (this.macos()) return { arch: 'arm64', confidence: 'low' }
    return { arch: 'x86_64', confidence: 'low' }
  }
}
